import axios from 'axios'

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8080'

export const messagingService = {
  // Send a new message
  async sendMessage(receiverId, offerId, message) {
    try {
      const response = await axios.post(`${API_BASE_URL}/messages/send`, {
        receiverId, // UUID of the seller (receiver)
        offerId,    // UUID of the offer
        message     // Text message content
      })
      return response.data
    } catch (error) {
      throw error
    }
  },

  // Get all conversations for current user
  async getConversations() {
    try {
      const response = await axios.get(`${API_BASE_URL}/messages/conversations`)
      return response.data
    } catch (error) {
      throw error
    }
  },

  // Get conversation with specific partner and offer
  async getConversation(conversationId, limit = 10, offset = 0) {
    try {
      const response = await axios.get(`${API_BASE_URL}/messages/conversation/${conversationId}`, {
        params: { limit, offset }
      })
      return response.data
    } catch (error) {
      throw error
    }
  },

  // Get messages for specific offer
  async getMessagesByOffer(offerId) {
    try {
      const response = await axios.get(`${API_BASE_URL}/messages/offer/${offerId}`)
      return response.data
    } catch (error) {
      throw error
    }
  },

  // Mark message as read
  async markAsRead(messageId) {
    try {
      const response = await axios.patch(`${API_BASE_URL}/messages/mark-read/${messageId}`)
      return response.data
    } catch (error) {
      throw error
    }
  },

  // Mark conversation as read
  async markConversationAsRead(conversationId) {
    try {
      const response = await axios.patch(`${API_BASE_URL}/messages/mark-conversation-read/${conversationId}`)
      return response.data
    } catch (error) {
      throw error
    }
  },

  // Get unread message count
  async getUnreadCount() {
    try {
      const response = await axios.get(`${API_BASE_URL}/messages/unread-count`)
      return response.data
    } catch (error) {
      throw error
    }
  }
} 